import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Grid, GridColumn, GridDetailRow, GridToolbar } from '@progress/kendo-react-grid';
import './TenderingManager.scss';
import {process} from '@progress/kendo-data-query';

import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import TenderingQuote from './TenderingQuote';

const dataState = {
    sort: [],
    take: 10,
    skip: 0,
  };

class RFQDetail extends GridDetailRow {

    constructor(){
        super();
       this.state = {
       
        dataState: dataState
// dataItem :this.props.dataItem
        };
    }
   

    componentDidMount(){
       
       
    }

    expandChange = (event) => {
        this.state.filteredQuotationArray = [];
			for(var i=0; i<this.props.dataItem.quoteData.length; i++){
				if(this.props.dataItem.quoteData[i].RFQ_REQ_NR == event.dataItem.RFQ_REQ_NR){
					this.state.filteredQuotationArray.push(this.props.dataItem.quoteData[i]);
				}
			}
        const isExpanded =
            event.dataItem.expanded === undefined ?
                event.dataItem.aggregates : event.dataItem.expanded;
        event.dataItem.expanded = !isExpanded;
        // event.dataItem.rfqData = this.state.freightRFQArray;
        event.dataItem.quoteData = this.state.filteredQuotationArray;
        event.dataItem.awardQuotation =  this.props.dataItem.awardQuotation;
        this.setState({ ...this.state });
    }

    // RFQGridChange = (event) => {
    //     const selectedState = getSelectedState({
    //       event,
    //       selectedState: this.state.selectedState,
    //       dataItemKey: DATA_ITEM_KEY,
    //     });
    
    //     this.setState({ selectedState });
    //   };
  

    render() {
        const dataItem = this.props.dataItem;
       
        console.log("Detail Component" +dataItem)
        return (
            <div className = "TenderingRFQ">
                
               {/* <RFQRequestDetails data = {this.props.dataItem}></RFQRequestDetails> */}
                <Grid 
                ScrollMode="scrollable"
                pageable = {true}
                style={{ height: "600px", width: 'auto'}} 
                data={process(dataItem.rfqData, this.state.dataState)}
                {...this.state.dataState}
                 onDataStateChange={(e) => {
                this.setState({ dataState: e.dataState });
                }} 
              //  data={dataItem.rfqData}
                 detail= {TenderingQuote}
                 expandField="expanded"
                 onExpandChange={this.expandChange}
               
                 >
                  

                    <GridColumn field = "" title = " " width = "10px"></GridColumn>
                    <GridColumn field = "RFQNumber" title = " " width = "150px"></GridColumn>
                    <GridColumn field = "bidManager" title = " " width = "150px"></GridColumn>
                    <GridColumn field = "RFQ_MAX_RESP_DUR" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "RFQ_CURRCODE016" title = " " width="100px" ></GridColumn>
                    <GridColumn field = "AwardedCarrierData" title = " " width="100px"></GridColumn>
                    <GridColumn field = "RFQ_CARRIER_SCAC" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "proposedCarrier" title = " " width="120px"></GridColumn>
                    <GridColumn field = "RFQ_LIFECYCLE" title = " " width="120px"></GridColumn>
                    <GridColumn field = "response" title = " " width = "120px"></GridColumn>
                    <GridColumn field = "QUOT_AMOUNTSUB" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "rejectionReason" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "rejectionReasonComments" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_ACC_RESULT" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "YTEND_RESP_STATUS" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "QUOT_STOP_DATE_FLAG" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "RFQ_RESP_DUE_DTIME" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "RFQ_START_DATETIME" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "RFQ_END_DATETIME" title = " " width = "100px"></GridColumn>
                    <GridColumn field = "submissionDateTime" title = " " width = "150px"></GridColumn>

                </Grid>
            </div>
        );
    }
}

export default RFQDetail;